import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M3 17h18V5H3v12zM9 7l7 4-7 4V7z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 7v8l7-4zm12-4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"
})), 'OndemandVideoTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/OndemandVideoTwoTone.js
// module id = 5135
// module chunks = 2